export default "__VITE_ASSET__DR97nLtG__"